import { Box, BoxProps } from '@mui/material';
import React from 'react';
import { useProfilePhoto } from '../../hooks/useProfilePhoto';
import { colors } from '../../styles/theme/colors';

type ProfilePhotoProps = { imageSrc?: string };

type ProfilePhotoFrameProps = BoxProps;

export function ConsultantProfilePhoto({ imageSrc }: ProfilePhotoProps) {
    const { fallbackSrc, profilePhotoSrc } = useProfilePhoto({ profilePhoto: imageSrc });

    const safeImageSrc = profilePhotoSrc || fallbackSrc;

    return (
        <ProfilePhotoFrame>
            <Box
                sx={{
                    backgroundImage: `url(${safeImageSrc})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '100%;',
                }}
            />
        </ProfilePhotoFrame>
    );
}

function ProfilePhotoFrame({ sx, children, ...props }: ProfilePhotoFrameProps) {
    return (
        <Box
            sx={{
                borderRadius: '50%',
                width: '240px',
                height: '240px',
                overflow: 'hidden',
                border: `4px solid ${colors.white}`,
                marginBottom: 4,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
}
